import React from "react";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import ChartistGraph from "react-chartist";
import withStyles from "@material-ui/core/styles/withStyles";

import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";

import Timeline from "@material-ui/icons/Timeline";

import loadContent from "core-module/hoc/loadContent";

import chartsStyle from "assets/jss/material-dashboard-pro-react/views/chartsStyle.jsx";

var Tooltip = require("chartist-plugin-tooltip");
var CtAxisTitle = require("chartist-plugin-axistitle");

var delays2 = 10,
  durations2 = 500;

const dataHourlyChart = {
  options: {
    reverseData: true,
    horizontalBars: true,
    seriesBarDistance: 10,
    stackBars: true,
    chartPadding: {
      right: 0,
      bottom: 30,
      left: 0
    },
    axisX: {
      showGrid: true,
      scaleMinSpace: 60
    },
    axisY: {
      showGrid: true,
      width: "40px"
    },
    low: 0,
    height: "1000px",
    plugins: [
      Tooltip({
        valueTransform: e => {
          return e + " GB";
        }
      }),
      CtAxisTitle({
        axisX: {
          axisTitle: "Data used (GB)",
          axisClass: "ct-axis-title",
          offset: {
            x: 0,
            y: 50
          },
          textAnchor: "middle"
        }
      })
    ]
  },
  responsiveOptions: [
    [
      "screen and (max-width: 640px)",
      {
        seriesBarDistance: 5,
        axisX: {
          labelInterpolationFnc: function(value) {
            return value[0];
          }
        }
      }
    ]
  ],
  animation: {
    draw: function(data) {
      if (data.type === "bar") {
        data.element.animate({
          opacity: {
            begin: (data.index + 1) * delays2,
            dur: durations2,
            from: 0,
            to: 1,
            easing: "ease"
          }
        });
      }
    }
  }
};

const DataCalendar = props => {
  const { classes } = props;

  let labels = [];
  for (let i = 0; i < 24; i++) {
    if (i < 10) {
      labels.push(`0${i}:00`);
    } else {
      labels.push(`${i}:00`);
    }
  }

  const highestPoint =
    "aggregate" in props.getData("data") &&
    Array.isArray(props.getData("data").aggregate)
      ? Math.max(...props.getData("data").aggregate)
      : 1;
  const high =
    highestPoint < 10
      ? Math.floor(highestPoint / 1) + 1
      : Math.floor(highestPoint / 10) + 10;
  const date = new Date(Number(props.ids.broadbandgraphic) * 1000);

  // I KNOW THE CLASSNAMES ARE INVERTED. BUT THIS WORKS I DONT KNOW WHY !!!!
  let series = [
    {
      value: props.getData("data").downstream,
      className: "ct-chart-datausageperday-serie-upstream"
    },
    {
      value: props.getData("data").upstream,
      className: "ct-chart-datausageperday-serie-downstream"
    }
  ];

  return (
    <Card>
      <CardHeader color="primary" icon>
        <CardIcon color="primary">
          <Timeline />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>
          Data usage on {date.toDateString(date)}
        </h4>
      </CardHeader>
      <CardBody>
        <GridContainer justify="center">
          <GridItem xs={6}>
            <GridContainer justify="center">
              <GridItem xs={6}>
                <p className={classes.cardCategory}>
                  <span className="badge-square badge-success " /> Upstream
                </p>
              </GridItem>
              <GridItem xs={6}>
                <p className={classes.cardCategory}>
                  <span className="badge-square badge-primaryDarkBlue " />{" "}
                  Downstream
                </p>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12}>
            <div className="chart-wrapper-for-tooltip">
              <ChartistGraph
                className="ct-chart-datausageperday"
                data={{
                  labels: labels,
                  series
                }}
                type="Bar"
                options={{ ...dataHourlyChart.options, high }}
                listener={dataHourlyChart.animation}
              />
            </div>
            <br />
            <br />
          </GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  );
};

export default withStyles(chartsStyle)(
  loadContent("user.session/broadbandgraphic.props", DataCalendar)
);
